module.exports = __webpack_public_path__ + "static/media/hamburger.c996a850.svg";